import gs1Instance from '../api-index'

const { get, post } = gs1Instance;

const getSummary = async (params = {}) => {
    const response = await get(`/api/sscc/summary`, { params });
    return response.data;
};


const getItemsCommissioned = async (payload = {}) => {
    const response = await post(`/gs1/standard/label/commission/table`, payload);
    return response.data;
}


const getItemsPacked = async (params = {}) => {
    const response = await get(`/gs1/standard/label/pack/table`, { params });
    return response.data;
}


const getItemsShipped = async (params = {}) => {
    const response = await get(`/gs1/standard/label/ship/table`, { params });
    return response.data;
}


const getPackSize = async (params = {}) => {
    const response = await get(`/gs1/standard/label/pack/size/${params.prodId}/${params.clientEmail}`);
    return response.data;
}

const getPackContent = async (params = {}) => {
    const response = await get(`/gs1/standard/label/pack/content/${params.clientId}/${params.barcode}`);
    return response.data;
}



export {
    getSummary,
    getItemsCommissioned,
    getItemsPacked,
    getItemsShipped,
    getPackSize,};